'use strict';

// Billings controller
angular.module('billings').constant('clientTokenPath', '/billings/client_token').controller('BillingsController', [
  '$rootScope',
  '$scope',
  '$stateParams',
  '$location',
  'Authentication',
  'ConfigData',
  'MobileApps',
	'Billings',
	'SubscriptionMain',
  'SweetAlert',
  'Utilities',
  '$state',
  '$timeout',
  '$window',
  function (
    $rootScope,
    $scope,
    $stateParams,
    $location,
    Authentication,
    ConfigData,
    MobileApps,
		Billings,
		SubscriptionMain,
    SweetAlert,
    Utilities,
    $state,
    $timeout,
    $window
    ) {
    $scope.nbOfApps = 0;
    $scope.authentication = Authentication;
    $scope.mobileApps = [];
    $scope.legalEntity = 'business';
    $scope.paymentMethodToAdd = undefined;

    $scope.processing = false;
    $scope.loadedStatus = false;

    var client;
    $scope.paymentData = {
      paymentMethod: 'creditcard',
      nonce: undefined
    };

    $scope.client = null;
    $scope.threeDSecure = null;
	$scope.hostedFields = null;
	$scope.paypalCheckout = null;

	$scope.billingCountries = [
		{
			'name': 'Select Country',
			'code': ''
		},
		{
			'name': 'Afghanistan',
			'code': 'AF'
		},
		{
			'name': 'Åland',
			'code': 'AX'
		},
		{
			'name': 'Albania',
			'code': 'AL'
		},
		{
			'name': 'Algeria',
			'code': 'DZ'
		},
		{
			'name': 'American Samoa',
			'code': 'AS'
		},
		{
			'name': 'Andorra',
			'code': 'AD'
		},
		{
			'name': 'Angola',
			'code': 'AO'
		},
		{
			'name': 'Anguilla',
			'code': 'AI'
		},
		{
			'name': 'Antarctica',
			'code': 'AQ'
		},
		{
			'name': 'Antigua and Barbuda',
			'code': 'AG'
		},
		{
			'name': 'Argentina',
			'code': 'AR'
		},
		{
			'name': 'Armenia',
			'code': 'AM'
		},
		{
			'name': 'Aruba',
			'code': 'AW'
		},
		{
			'name': 'Australia',
			'code': 'AU'
		},
		{
			'name': 'Austria',
			'code': 'AT'
		},
		{
			'name': 'Azerbaijan',
			'code': 'AZ'
		},
		{
			'name': 'Bahamas',
			'code': 'BS'
		},
		{
			'name': 'Bahrain',
			'code': 'BH'
		},
		{
			'name': 'Bangladesh',
			'code': 'BD'
		},
		{
			'name': 'Barbados',
			'code': 'BB'
		},
		{
			'name': 'Belarus',
			'code': 'BY'
		},
		{
			'name': 'Belgium',
			'code': 'BE'
		},
		{
			'name': 'Belize',
			'code': 'BZ'
		},
		{
			'name': 'Benin',
			'code': 'BJ'
		},
		{
			'name': 'Bermuda',
			'code': 'BM'
		},
		{
			'name': 'Bhutan',
			'code': 'BT'
		},
		{
			'name': 'Bolivia',
			'code': 'BO'
		},
		{
			'name': 'Bonaire, Sint Eustatius and Saba',
			'code': 'BQ'
		},
		{
			'name': 'Bosnia and Herzegovina',
			'code': 'BA'
		},
		{
			'name': 'Botswana',
			'code': 'BW'
		},
		{
			'name': 'Bouvet Island',
			'code': 'BV'
		},
		{
			'name': 'Brazil',
			'code': 'BR'
		},
		{
			'name': 'British Indian Ocean Territory',
			'code': 'IO'
		},
		{
			'name': 'Brunei Darussalam',
			'code': 'BN'
		},
		{
			'name': 'Bulgaria',
			'code': 'BG'
		},
		{
			'name': 'Burkina Faso',
			'code': 'BF'
		},
		{
			'name': 'Burundi',
			'code': 'BI'
		},
		{
			'name': 'Cambodia',
			'code': 'KH'
		},
		{
			'name': 'Cameroon',
			'code': 'CM'
		},
		{
			'name': 'Canada',
			'code': 'CA'
		},
		{
			'name': 'Cape Verde',
			'code': 'CV'
		},
		{
			'name': 'Cayman Islands',
			'code': 'KY'
		},
		{
			'name': 'Central African Republic',
			'code': 'CF'
		},
		{
			'name': 'Chad',
			'code': 'TD'
		},
		{
			'name': 'Chile',
			'code': 'CL'
		},
		{
			'name': 'China',
			'code': 'CN'
		},
		{
			'name': 'Christmas Island',
			'code': 'CX'
		},
		{
			'name': 'Cocos (Keeling) Islands',
			'code': 'CC'
		},
		{
			'name': 'Colombia',
			'code': 'CO'
		},
		{
			'name': 'Comoros',
			'code': 'KM'
		},
		{
			'name': 'Congo (Brazzaville)',
			'code': 'CG'
		},
		{
			'name': 'Congo (Kinshasa)',
			'code': 'CD'
		},
		{
			'name': 'Cook Islands',
			'code': 'CK'
		},
		{
			'name': 'Costa Rica',
			'code': 'CR'
		},
		{
			'name': 'Côte d\'Ivoire',
			'code': 'CI'
		},
		{
			'name': 'Croatia',
			'code': 'HR'
		},
		{
			'name': 'Cuba',
			'code': 'CU'
		},
		{
			'name': 'Curaçao',
			'code': 'CW'
		},
		{
			'name': 'Cyprus',
			'code': 'CY'
		},
		{
			'name': 'Czech Republic',
			'code': 'CZ'
		},
		{
			'name': 'Denmark',
			'code': 'DK'
		},
		{
			'name': 'Djibouti',
			'code': 'DJ'
		},
		{
			'name': 'Dominica',
			'code': 'DM'
		},
		{
			'name': 'Dominican Republic',
			'code': 'DO'
		},
		{
			'name': 'Ecuador',
			'code': 'EC'
		},
		{
			'name': 'Egypt',
			'code': 'EG'
		},
		{
			'name': 'El Salvador',
			'code': 'SV'
		},
		{
			'name': 'Equatorial Guinea',
			'code': 'GQ'
		},
		{
			'name': 'Eritrea',
			'code': 'ER'
		},
		{
			'name': 'Estonia',
			'code': 'EE'
		},
		{
			'name': 'Ethiopia',
			'code': 'ET'
		},
		{
			'name': 'Falkland Islands',
			'code': 'FK'
		},
		{
			'name': 'Faroe Islands',
			'code': 'FO'
		},
		{
			'name': 'Fiji',
			'code': 'FJ'
		},
		{
			'name': 'Finland',
			'code': 'FI'
		},
		{
			'name': 'France',
			'code': 'FR'
		},
		{
			'name': 'French Guiana',
			'code': 'GF'
		},
		{
			'name': 'French Polynesia',
			'code': 'PF'
		},
		{
			'name': 'French Southern Lands',
			'code': 'TF'
		},
		{
			'name': 'Gabon',
			'code': 'GA'
		},
		{
			'name': 'Gambia',
			'code': 'GM'
		},
		{
			'name': 'Georgia',
			'code': 'GE'
		},
		{
			'name': 'Germany',
			'code': 'DE'
		},
		{
			'name': 'Ghana',
			'code': 'GH'
		},
		{
			'name': 'Gibraltar',
			'code': 'GI'
		},
		{
			'name': 'Greece',
			'code': 'GR'
		},
		{
			'name': 'Greenland',
			'code': 'GL'
		},
		{
			'name': 'Grenada',
			'code': 'GD'
		},
		{
			'name': 'Guadeloupe',
			'code': 'GP'
		},
		{
			'name': 'Guam',
			'code': 'GU'
		},
		{
			'name': 'Guatemala',
			'code': 'GT'
		},
		{
			'name': 'Guernsey',
			'code': 'GG'
		},
		{
			'name': 'Guinea',
			'code': 'GN'
		},
		{
			'name': 'Guinea-Bissau',
			'code': 'GW'
		},
		{
			'name': 'Guyana',
			'code': 'GY'
		},
		{
			'name': 'Haiti',
			'code': 'HT'
		},
		{
			'name': 'Heard and McDonald Islands',
			'code': 'HM'
		},
		{
			'name': 'Honduras',
			'code': 'HN'
		},
		{
			'name': 'Hong Kong',
			'code': 'HK'
		},
		{
			'name': 'Hungary',
			'code': 'HU'
		},
		{
			'name': 'Iceland',
			'code': 'IS'
		},
		{
			'name': 'India',
			'code': 'IN'
		},
		{
			'name': 'Indonesia',
			'code': 'ID'
		},
		{
			'name': 'Iran',
			'code': 'IR'
		},
		{
			'name': 'Iraq',
			'code': 'IQ'
		},
		{
			'name': 'Ireland',
			'code': 'IE'
		},
		{
			'name': 'Isle of Man',
			'code': 'IM'
		},
		{
			'name': 'Israel',
			'code': 'IL'
		},
		{
			'name': 'Italy',
			'code': 'IT'
		},
		{
			'name': 'Jamaica',
			'code': 'JM'
		},
		{
			'name': 'Japan',
			'code': 'JP'
		},
		{
			'name': 'Jersey',
			'code': 'JE'
		},
		{
			'name': 'Jordan',
			'code': 'JO'
		},
		{
			'name': 'Kazakhstan',
			'code': 'KZ'
		},
		{
			'name': 'Kenya',
			'code': 'KE'
		},
		{
			'name': 'Kiribati',
			'code': 'KI'
		},
		{
			'name': 'Korea, North',
			'code': 'KP'
		},
		{
			'name': 'Korea, South',
			'code': 'KR'
		},
		{
			'name': 'Kuwait',
			'code': 'KW'
		},
		{
			'name': 'Kyrgyzstan',
			'code': 'KG'
		},
		{
			'name': 'Laos',
			'code': 'LA'
		},
		{
			'name': 'Latvia',
			'code': 'LV'
		},
		{
			'name': 'Lebanon',
			'code': 'LB'
		},
		{
			'name': 'Lesotho',
			'code': 'LS'
		},
		{
			'name': 'Liberia',
			'code': 'LR'
		},
		{
			'name': 'Libya',
			'code': 'LY'
		},
		{
			'name': 'Liechtenstein',
			'code': 'LI'
		},
		{
			'name': 'Lithuania',
			'code': 'LT'
		},
		{
			'name': 'Luxembourg',
			'code': 'LU'
		},
		{
			'name': 'Macau',
			'code': 'MO'
		},
		{
			'name': 'Macedonia',
			'code': 'MK'
		},
		{
			'name': 'Madagascar',
			'code': 'MG'
		},
		{
			'name': 'Malawi',
			'code': 'MW'
		},
		{
			'name': 'Malaysia',
			'code': 'MY'
		},
		{
			'name': 'Maldives',
			'code': 'MV'
		},
		{
			'name': 'Mali',
			'code': 'ML'
		},
		{
			'name': 'Malta',
			'code': 'MT'
		},
		{
			'name': 'Marshall Islands',
			'code': 'MH'
		},
		{
			'name': 'Martinique',
			'code': 'MQ'
		},
		{
			'name': 'Mauritania',
			'code': 'MR'
		},
		{
			'name': 'Mauritius',
			'code': 'MU'
		},
		{
			'name': 'Mayotte',
			'code': 'YT'
		},
		{
			'name': 'Mexico',
			'code': 'MX'
		},
		{
			'name': 'Micronesia',
			'code': 'FM'
		},
		{
			'name': 'Moldova',
			'code': 'MD'
		},
		{
			'name': 'Monaco',
			'code': 'MC'
		},
		{
			'name': 'Mongolia',
			'code': 'MN'
		},
		{
			'name': 'Montenegro',
			'code': 'ME'
		},
		{
			'name': 'Montserrat',
			'code': 'MS'
		},
		{
			'name': 'Morocco',
			'code': 'MA'
		},
		{
			'name': 'Mozambique',
			'code': 'MZ'
		},
		{
			'name': 'Myanmar',
			'code': 'MM'
		},
		{
			'name': 'Namibia',
			'code': 'NA'
		},
		{
			'name': 'Nauru',
			'code': 'NR'
		},
		{
			'name': 'Nepal',
			'code': 'NP'
		},
		{
			'name': 'Netherlands',
			'code': 'NL'
		},
		{
			'name': 'Netherlands Antilles',
			'code': 'AN'
		},
		{
			'name': 'New Caledonia',
			'code': 'NC'
		},
		{
			'name': 'New Zealand',
			'code': 'NZ'
		},
		{
			'name': 'Nicaragua',
			'code': 'NI'
		},
		{
			'name': 'Niger',
			'code': 'NE'
		},
		{
			'name': 'Nigeria',
			'code': 'NG'
		},
		{
			'name': 'Niue',
			'code': 'NU'
		},
		{
			'name': 'Norfolk Island',
			'code': 'NF'
		},
		{
			'name': 'Northern Mariana Islands',
			'code': 'MP'
		},
		{
			'name': 'Norway',
			'code': 'NO'
		},
		{
			'name': 'Oman',
			'code': 'OM'
		},
		{
			'name': 'Pakistan',
			'code': 'PK'
		},
		{
			'name': 'Palau',
			'code': 'PW'
		},
		{
			'name': 'Palestine',
			'code': 'PS'
		},
		{
			'name': 'Panama',
			'code': 'PA'
		},
		{
			'name': 'Papua New Guinea',
			'code': 'PG'
		},
		{
			'name': 'Paraguay',
			'code': 'PY'
		},
		{
			'name': 'Peru',
			'code': 'PE'
		},
		{
			'name': 'Philippines',
			'code': 'PH'
		},
		{
			'name': 'Pitcairn',
			'code': 'PN'
		},
		{
			'name': 'Poland',
			'code': 'PL'
		},
		{
			'name': 'Portugal',
			'code': 'PT'
		},
		{
			'name': 'Puerto Rico',
			'code': 'PR'
		},
		{
			'name': 'Qatar',
			'code': 'QA'
		},
		{
			'name': 'Reunion',
			'code': 'RE'
		},
		{
			'name': 'Romania',
			'code': 'RO'
		},
		{
			'name': 'Russian Federation',
			'code': 'RU'
		},
		{
			'name': 'Rwanda',
			'code': 'RW'
		},
		{
			'name': 'Saint Barthélemy',
			'code': 'BL'
		},
		{
			'name': 'Saint Helena',
			'code': 'SH'
		},
		{
			'name': 'Saint Kitts and Nevis',
			'code': 'KN'
		},
		{
			'name': 'Saint Lucia',
			'code': 'LC'
		},
		{
			'name': 'Saint Martin (French part)',
			'code': 'MF'
		},
		{
			'name': 'Saint Pierre and Miquelon',
			'code': 'PM'
		},
		{
			'name': 'Saint Vincent and the Grenadines',
			'code': 'VC'
		},
		{
			'name': 'Samoa',
			'code': 'WS'
		},
		{
			'name': 'San Marino',
			'code': 'SM'
		},
		{
			'name': 'Sao Tome and Principe',
			'code': 'ST'
		},
		{
			'name': 'Saudi Arabia',
			'code': 'SA'
		},
		{
			'name': 'Senegal',
			'code': 'SN'
		},
		{
			'name': 'Serbia',
			'code': 'RS'
		},
		{
			'name': 'Seychelles',
			'code': 'SC'
		},
		{
			'name': 'Sierra Leone',
			'code': 'SL'
		},
		{
			'name': 'Singapore',
			'code': 'SG'
		},
		{
			'name': 'Sint Maarten (Dutch part)',
			'code': 'SX'
		},
		{
			'name': 'Slovakia',
			'code': 'SK'
		},
		{
			'name': 'Slovenia',
			'code': 'SI'
		},
		{
			'name': 'Solomon Islands',
			'code': 'SB'
		},
		{
			'name': 'Somalia',
			'code': 'SO'
		},
		{
			'name': 'South Africa',
			'code': 'ZA'
		},
		{
			'name': 'South Georgia and South Sandwich Islands',
			'code': 'GS'
		},
		{
			'name': 'South Sudan',
			'code': 'SS'
		},
		{
			'name': 'Spain',
			'code': 'ES'
		},
		{
			'name': 'Sri Lanka',
			'code': 'LK'
		},
		{
			'name': 'Sudan',
			'code': 'SD'
		},
		{
			'name': 'Suriname',
			'code': 'SR'
		},
		{
			'name': 'Svalbard and Jan Mayen Islands',
			'code': 'SJ'
		},
		{
			'name': 'Swaziland',
			'code': 'SZ'
		},
		{
			'name': 'Sweden',
			'code': 'SE'
		},
		{
			'name': 'Switzerland',
			'code': 'CH'
		},
		{
			'name': 'Syria',
			'code': 'SY'
		},
		{
			'name': 'Taiwan',
			'code': 'TW'
		},
		{
			'name': 'Tajikistan',
			'code': 'TJ'
		},
		{
			'name': 'Tanzania',
			'code': 'TZ'
		},
		{
			'name': 'Thailand',
			'code': 'TH'
		},
		{
			'name': 'Timor-Leste',
			'code': 'TL'
		},
		{
			'name': 'Togo',
			'code': 'TG'
		},
		{
			'name': 'Tokelau',
			'code': 'TK'
		},
		{
			'name': 'Tonga',
			'code': 'TO'
		},
		{
			'name': 'Trinidad and Tobago',
			'code': 'TT'
		},
		{
			'name': 'Tunisia',
			'code': 'TN'
		},
		{
			'name': 'Turkey',
			'code': 'TR'
		},
		{
			'name': 'Turkmenistan',
			'code': 'TM'
		},
		{
			'name': 'Turks and Caicos Islands',
			'code': 'TC'
		},
		{
			'name': 'Tuvalu',
			'code': 'TV'
		},
		{
			'name': 'Uganda',
			'code': 'UG'
		},
		{
			'name': 'Ukraine',
			'code': 'UA'
		},
		{
			'name': 'United Arab Emirates',
			'code': 'AE'
		},
		{
			'name': 'United Kingdom',
			'code': 'GB'
		},
		{
			'name': 'United States Minor Outlying Islands',
			'code': 'UM'
		},
		{
			'name': 'United States of America',
			'code': 'US'
		},
		{
			'name': 'Uruguay',
			'code': 'UY'
		},
		{
			'name': 'Uzbekistan',
			'code': 'UZ'
		},
		{
			'name': 'Vanuatu',
			'code': 'VU'
		},
		{
			'name': 'Vatican City',
			'code': 'VA'
		},
		{
			'name': 'Venezuela',
			'code': 'VE'
		},
		{
			'name': 'Vietnam',
			'code': 'VN'
		},
		{
			'name': 'Virgin Islands, British',
			'code': 'VG'
		},
		{
			'name': 'Virgin Islands, U.S.',
			'code': 'VI'
		},
		{
			'name': 'Wallis and Futuna Islands',
			'code': 'WF'
		},
		{
			'name': 'Western Sahara',
			'code': 'EH'
		},
		{
			'name': 'Yemen',
			'code': 'YE'
		},
		{
			'name': 'Zambia',
			'code': 'ZM'
		},
		{
			'name': 'Zimbabwe',
			'code': 'ZW'
		}
	];
	$scope.countryName = $scope.billingCountries[0];


    $scope.initDetailView = function() {
	  $scope.enableInvoiceButton = false;
		$scope.paymentData.paymentMethod = undefined;
		$scope.getUserSubscription();

	  $scope.loadedStatus = false;
	  $scope.billings = Billings.query(function (response) {
		  $scope.loadedStatus = true;
		  $scope.loadQuaderno(50);
		});

      $scope._fetchMobileApps(function(err, mobileApps) {
        if(err) {
          return;
        }

        $scope.mobileApps = mobileApps || [];
        $scope._countNumberOfAppsThatUserOwns();
      });
    };


	$scope.initCreateBillingView = function() {

		// Init data
		$scope.firstName = $scope.authentication.user.firstName;
		$scope.lastName = $scope.authentication.user.lastName;
		$scope.email = $scope.authentication.user.email;
	};


	/**
	 * Waits till the Quaderno script has been loaded and then displays the
	 * invoices button if there are any
	 */
	$scope.loadQuaderno = function(maxTries) {
		// We keep retrying till the quaderno script has either been loaded or
		// the max tries are reached
		if (!$window.QuadernoBilling) {
			if (maxTries > 0) {
				$timeout(function() {
					$scope.loadQuaderno(--maxTries);
				}, 100);
			}
			return;
		}

		if ($scope.billings && $scope.billings.length !== 0 &&
			$scope.authentication.user && $scope.authentication.user._id && ConfigData && ConfigData.quaderno && ConfigData.quaderno.key) {
			var customerId = $scope.billings[0].btUserId;

			jQuery(function($) {
				var handler = $window.QuadernoBilling.configure({key: ConfigData.quaderno.key, customer_id: customerId, editable: false});
				var billingButton = $('#billing-button');
				billingButton.on('click', function(e) {
					e.preventDefault();
					handler.open();
				});

				$timeout(function() {
					$scope.enableInvoiceButton = true;
				});
			});
		}
	};


	$scope.clearSetup = function () {
		$scope.paymentData.paymentMethod = undefined;
		if ($scope.paypalCheckout) {
			$scope.paypalCheckout.teardown();
		}
		//$('#bt-paypal').html('');
		if ($scope.hostedFields) {
			$scope.hostedFields.teardown();
		}
	};

	/**
	 * Waits till the placeholder for the paypal button get displayed
	 * and then uses it to add the braintree paypal button
	 */
	$scope.__setupCardFields = function (clientInstance, maxTries) {
		if (maxTries === undefined) {
			maxTries = 50;
		}

		if ($('#cc-number').length === 0) {
			$timeout(function () {
				$scope.__setupCardFields(clientInstance, --maxTries);
			}, 100);
			return;
		}
	};
	  


	/**
	 * Waits till the placeholder for the paypal button get displayed
	 * and then uses it to add the braintree paypal button
	 */
	$scope.__setupPaypalButton = function (clientInstance, maxTries) {
		if (maxTries === undefined) {
			maxTries = 50;
		}

		if ($('#bt-paypal').length === 0) {
			$timeout(function () {
				$scope.__setupPaypalButton(clientInstance, --maxTries);
			}, 100);
			return;
		}
	};

	/**
	 * Adds a new payment method
	 */
	$scope.addPaymentMethod = function (paymentMethod) {
		if (paymentMethod === undefined) {
			// No payment method set to be added
			return;
		}

		if (paymentMethod === 'paypal') {
			if ($scope.paymentData.nonce) {
				$scope.processing = true;
				$scope.__addPaymentMethod($scope.paymentData.nonce);
			} else {
				Utilities.showMessage(
					'Problem!',
					'You have to add a PayPal account first. To do that click on the "PayPal" button on the left side.',
					'warning'
				);
			}
		} else if (paymentMethod === 'creditcard') {
			let state = $scope.hostedFields.getState();
			let validData = Object.keys(state.fields).every(function (key) {
				return state.fields[key].isValid;
			});
			if (!validData) {
				Utilities.showMessage(
					'Problem!',
					'The credit card details are not valid. Please verify and resubmit.',
					'error'
				);
				return;
			}

			if ($scope.billings && $scope.billings.length > 0) {
				$scope.processing = true;
				//get the billing info to pass to the bank when verifing the credit card
				Billings.get({ billingId: $scope.billings[0]._id },
					function (response) {
						$scope.billingData = response;
						//tokenize card number and exparation date
						$scope.hostedFields.tokenize(function (err, payload) {
							if (err || (payload && !payload.nonce)) {
								Utilities.showMessage(
									'Problem!',
									'The credit card details could not be processed. Please verify and resubmit.',
									'error'
								);
								$scope.processing = false;
								return;
							}
							let country = $scope.billingCountries.find(country => country.name === $scope.billingData.countryName);
							let streetAddress = $scope.billingData.street || '';
							if ($scope.billingData.streetNumber) {
								streetAddress = streetAddress + ' ' + $scope.billingData.streetNumber;
							}
							const phone = $scope.billingData.phone || '';
							const cardDetails = {
								amount: '0.00',
								nonce: payload.nonce,
								email: $scope.billingData.email || '',
								challengeRequested: true,	//recomended setting for subsription, when the payment may be delayed
								billingAddress: {
									givenName: $scope.billingData.firstName || '',
									surname: $scope.billingData.lastName || '',
									phoneNumber: phone.replace(/[^0-9]/g, ''), // remove none-numerical characters from phone number
									streetAddress: streetAddress,
									locality: $scope.billingData.city || '',
									postalCode: $scope.billingData.postalCode || '',
									countryCodeAlpha2: country.code
								}
							};
							if (payload.details && payload.details.bin) {
								cardDetails.bin = payload.details.bin;
							}
							//verify the card details with 3D Security 
							//if sucesfuul, we recive 'encanced' nonce from Braintree 
							$scope.threeDSecure.verifyCard(cardDetails, function (verifyError, verifyResponse) {
								if (verifyError) {
									Utilities.showMessage(
										'Problem!',
										'The credit card autorisation failed.<br>Please try agian or try with another card.',
										'error'
									);
									$scope.clearSetup();
									$scope.processing = false;
									return;
								}
								$scope.billingData = null;
								$scope.clearSetup();
								//if liabilityShifted is true, means 3D Secure worked and authentication succeeded
								//if liabilityShiftPossible and liabilityShifted are false and the 3D Secure is not aviable
								if (
									(verifyResponse.threeDSecureInfo && verifyResponse.threeDSecureInfo.liabilityShiftPossible && verifyResponse.threeDSecureInfo.liabilityShifted) ||
									!verifyResponse.threeDSecureInfo ||
									(verifyResponse.threeDSecureInfo && ['authentication_unavailable', 'authenticate_unable_to_authenticate'].includes(verifyResponse.threeDSecureInfo.status))
								) { 
									$scope.__addPaymentMethod(verifyResponse.nonce);
								} else {
									Utilities.showMessage(
										'Problem!',
										'The credit card autorisation failed.<br>Please try agian or try with another card.',
										'error'
									);
									$scope.processing = false;
									return;
								}
							});
						});
					},
					function (errResponse) {
						Utilities.showMessage(
							'Problem!',
							'There was problem retriving the billing information. Please contact support.',
							'error'
						);
						$scope.processing = false;
						return;
					}
				);
			} else {
				Utilities.showMessage(
					'Problem!',
					'No billing data found for this client.',
					'error'
				);
			}
		}
	};

	  /**
	   * Sets a new default payment method in the local data so that
	   * it gets displayed correctly for the user
       */
	  function setDefaultPaymentMethod(token) {
		  $scope.billings.forEach(function(billing) {
			  billing.paypalAccounts.forEach(function(paypalAccount) {
				  if (paypalAccount.token === token) {
					  paypalAccount.default = true;
				  } else {
					  paypalAccount.default = false;
				  }
			  });
			  billing.creditCards.forEach(function(creditCard) {
				  if (creditCard.token === token) {
					  creditCard.default = true;
				  } else {
					  creditCard.default = false;
				  }
			  });
		  });
	  }


	  /**
	   * Adds a new payment method
	   */
	  $scope.__addPaymentMethod = function(none) {
		  Billings.addPaymentMethod({
				  none: none
			  }, function(result) {
				  $scope.processing = false;
				  $scope.paymentData.paymentMethod = undefined;

				  if (result.hasOwnProperty('paypalAccount')) {
					  if (!$scope.billings[0].hasOwnProperty('paypalAccounts')) {
						  $scope.billings[0].paypalAccounts = [];
					  }
					  $scope.billings[0].paypalAccounts.push(result.paypalAccount);
					  setDefaultPaymentMethod(result.paypalAccount.token);
					  $scope.clearSetup();
				  }
				  if (result.hasOwnProperty('creditCard')) {
					  // Reset the data
					  $scope.paymentData.number = '';
					  $scope.paymentData.expirationDate = '';

					  if (!$scope.billings[0].hasOwnProperty('creditCards')) {
						  $scope.billings[0].creditCards = [];
					  }
					  $scope.billings[0].creditCards.push(result.creditCard);
					  setDefaultPaymentMethod(result.creditCard.token);
				  }

			  }, function(error) {
				  $scope.processing = false;
				  var errorMessage = 'The payment method could not be added. Please try again or contact our support!';
				  if (error.data && error.data.message) {
					  errorMessage = 'There was a problem adding the payment method:<br />' + error.data.message;
				  }
				  Utilities.showMessage(
					  'Problem!',
					  errorMessage,
					  'error'
				  );
			  }
		  );
	  };


	  /**
	   * Deletes a payment method after the user confirmed
	   * @param token The token of the payment method to delete
	   * @param isDefault If the payment method is currently the default one
	   */
	  $scope.deletePaymentMethod = function(token, isDefault) {
		  if (isDefault === true) {
			  // Make sure that the default payment method does not get deleted
			  // because that is the one that gets used by the active subscription
			  Utilities.showMessage(
				  'Problem!',
				  'This payment method can not be deleted because it is the default one. To delete it another payment method has to be set to default first!',
				  'warning'
			  );
			  return;
		  }

		  SweetAlert.swal(
			  {
				  title             : 'Are you sure?',
				  text              : 'This will delete the Payment Method forever and can not be recovered.',
				  type              : 'warning',
				  showCancelButton  : true,
				  confirmButtonColor: '#DD6B55',
				  confirmButtonText : 'Yes, delete it!',
				  cancelButtonText  : 'No, cancel!',
				  closeOnConfirm    : true,
				  closeOnCancel     : true
			  },
			  function (isConfirm) {
				  if (isConfirm) {
					  $scope.__deletePaymentMethod(token);
				  }
			  }
		  );
	  };


	  /**
	   * Deletes a payment method
	   * @param token The token of the payment method to delete
	   */
	  $scope.__deletePaymentMethod = function(token) {
		  $scope.loadedStatus = false;
		  Billings.deletePaymentMethod({
				  token: token
			  }, function(result) {
				  $scope.loadedStatus = true;

				  // Update the internal data that it gets displayed correctly
				  // to the users
				  var i, j, billing;
				  for (i=0;i<$scope.billings.length;i++) {
					  billing = $scope.billings[i];
					  for (j=0;j<billing.paypalAccounts.length;j++) {
						  if (billing.paypalAccounts[j].token === token) {
							  billing.paypalAccounts.splice(j, 1);
						  }
					  }
					  for (j=0;j<billing.creditCards.length;j++) {
						  if (billing.creditCards[j].token === token) {
							  billing.creditCards.splice(j, 1);
						  }
					  }
				  }
			  }, function(error) {
				  $scope.loadedStatus = true;

				  Utilities.showMessage(
					  'Problem!',
					  'The payment method could not be deleted. Please try again or contact our support!',
					  'error'
				  );
			  }
		  );
	  };


	  /**
	   * Sets a new default payment method
       */
	  $scope.setDefaultPaymentMethod = function(token) {
		  $scope.loadedStatus = false;

		  Billings.setDefaultPayment({
				  token: token
			  }, function(result) {
				  $scope.loadedStatus = true;

				  // Update the internal data that it gets displayed correctly
				  // to the users
				  setDefaultPaymentMethod(token);


			  }, function(error) {
				  $scope.loadedStatus = true;

				  var errorMessage = 'The default payment method could not be changed. Please try again or contact our support!';
				  if (error.data && error.data.message) {
					  errorMessage = 'There was a problem changing the default payment method:<br />' + error.data.message;
				  }
				  Utilities.showMessage(
					  'Problem!',
					  errorMessage,
					  'error'
				  );
			  }
		  );

	  };

	  $scope.isDataValid = function () {
		if (!$scope.firstName || !$scope.firstName.trim()) {
			$scope.error = 'Please add First Name.';
			return;
		}
		if (!$scope.lastName || !$scope.lastName.trim()) {
			$scope.error = 'Please add Last Name.';
			return;
		}
		if (!$scope.email || !$scope.email.trim()) {
			$scope.error = 'Please add email.';
			return;
		}
		if (!$scope.email.match(/.+\@.+\..+/)) {
			$scope.error = 'Please fill a valid email address.';
			return;
		}
		if (!$scope.street || !$scope.street.trim()) {
			$scope.error = 'Please add Street.';
			return;
		}
		if (!$scope.postalCode || !$scope.postalCode.trim()) {
			$scope.error = 'Please add Postal Code.';
			return;
		}
		if (!$scope.city || !$scope.city.trim()) {
			$scope.error = 'Please add City.';
			return;
		}
		if ($scope.countryName.code === '') {
			$scope.error = 'Please select a country from the list';
			return;
		}
		$scope.error = '';
		return true;
	};
	$scope.safeInput = function(input) {
		if (!input) {
			return '';
		}
		if (typeof input !== 'string') {
			return input;
		}
		return input.replace(/(<[^>]+>)/ig, '');
	};
	/**
	 * Submit the form
	 */
	$scope.submit = function() {
		if (!$scope.isDataValid())
		{
			return;
		}
		$scope.processing = true;
		if ($scope.paymentData.paymentMethod === 'creditcard') {
			$scope.hostedFields.tokenize(function (err, payload) {
				if (err || (payload && !payload.nonce)) {
					$scope.processing = false;
					Utilities.showMessage(
						'Problem!',
						'The payment method could not be processed. Please try again or contact our support!',
						'error'
					);
					return;
				}
				let streetAddress = $scope.street || '';
				if ($scope.streetNumber) {
					streetAddress = streetAddress + ' ' + $scope.streetNumber;
				}
				const phone = $scope.safeInput($scope.phone);
				const cardDetails = {
					amount: '0.00',
					nonce: payload.nonce,
					email: $scope.safeInput($scope.email),
					challengeRequested: true,	//recomended setting for subsription, when the payment may be delayed
					billingAddress: {
						givenName: $scope.safeInput($scope.firstName), 
						surname: $scope.safeInput($scope.lastName),
						phoneNumber: phone.replace(/[^0-9]/g, ''), // remove none-numerical characters from phone number
						streetAddress: $scope.safeInput(streetAddress),
						locality: $scope.safeInput($scope.city),
						postalCode: $scope.safeInput($scope.postalCode),
						countryCodeAlpha2: $scope.safeInput($scope.countryName.code)
					}
				};
				if (payload.details && payload.details.bin) {
					cardDetails.bin = payload.details.bin;
				}

				$scope.threeDSecure.verifyCard(cardDetails, function (verifyError, verifyResponse) {
					if (verifyError) {
						$scope.processing = false;
						Utilities.showMessage(
							'Problem!',
							'The default payment method could not be processed. Please try again or contact our support!',
							'error'
						);
						return;
					}
					$scope.create(verifyResponse.nonce);
				});
				
			});
		} else if ($scope.paymentData.paymentMethod === 'paypal') {
			$scope.create($scope.paymentData.nonce);
		}
	};

	/**
	 * Save the biling information on server and redirect to subscription page
	 */
    $scope.create = function (nonce) {

      // Create new Billing object
      var billing = new Billings({
        firstName         : $scope.safeInput(this.firstName),
        lastName          : $scope.safeInput(this.lastName),
        company           : $scope.legalEntity==='business'?$scope.safeInput(this.company):undefined,
        email             : $scope.safeInput(this.email),
        phone             : $scope.safeInput(this.phone),
        paymentMethodNonce: nonce,
        street            : $scope.safeInput(this.street),
        streetNumber      : $scope.safeInput(this.streetNumber),
        city              : $scope.safeInput(this.city),
        postalCode        : $scope.safeInput(this.postalCode),
        countryName       : $scope.safeInput(this.countryName.name),
        vatId             : $scope.safeInput(this.vatId),
        legalEntity       : $scope.safeInput($scope.legalEntity)
      });

      // Redirect after save
      billing.$save(function (response) {
        $scope.success = true;

        SweetAlert.swal({title: 'Billing submitted!', text: 'Now please choose a Payment Plan.', type: 'success'},
          function () {
            $rootScope.$broadcast('RefreshSignupStatus', null);
          }
        );

        // Update the billing data on the user so that it displays it correctly
        // in the signup status
        $scope.user._billing.billingDataEntered = true;

        $location.path('billings/subscribe');
        //

        // Clear form fields
        $scope.name = '';
        nonce = null;

      }, function (errorResponse) {
        $scope.error = errorResponse.data.message;
        $scope.processing = false;
      });
    };
    $scope.user = Authentication.user;


    // Remove existing Billing
    $scope.remove = function (billing) {
      if (billing) {
        billing.$remove();

        for (var i in $scope.billings) {
          if ($scope.billings [i] === billing) {
            $scope.billings.splice(i, 1);
          }
        }
      } else {
        $scope.billing.$remove(function () {
          $location.path('billings');
        });
      }
    };

    // Update existing Billing
    $scope.update = function () {
      var billing = $scope.billing;

      billing.$update(function () {
        $location.path('billings/' + billing._id);
      }, function (errorResponse) {
        $scope.error = errorResponse.data.message;
			});
			$scope.getUserSubscription(true);
    };

    // Find existing Billing
    $scope.findOne = function () {
      $scope.billing = Billings.get({
        billingId: $stateParams.billingId
			});
			$scope.getUserSubscription();
    };

	  $scope.editSubscription = function (billingId, currentPlan) {
		  if (currentPlan && currentPlan.toLowerCase() === 'enterprise') {
			  Utilities.showMessage(
				  'Problem!',
				  'Enterprise subscriptions can not be downgraded manually. Please contact support!',
				  'error'
			  );
			  return;
		  }

		  $state.go('editSubscription', {billingId: billingId});
	  };

    $scope._fetchMobileApps = function(callback) {
      MobileApps.query(function (response) {
        callback(null, response);
      }, callback);
    };

    $scope._countNumberOfAppsThatUserOwns = function() {
      $scope.mobileApps.forEach(function(mobileApp) {
        if(mobileApp.user && mobileApp.user._id === Authentication.user._id) {
          $scope.nbOfApps++;
        }
      });
		};
		
		/**
	   * Updates the current usersubscription information
	   */
	  $scope.getUserSubscription = function(forceRefresh) {
		  SubscriptionMain.getUserPlan(forceRefresh, function(err, currentUserSubscription) {
			  if (err) {
				  $scope.currentUserSubscription = {};
				  return;
				}
			  $scope.currentUserSubscription = currentUserSubscription;
		  });
	  };

  }
]);
